import Vue from 'vue'
import router from './router'
import App from './App.vue'
import '@/plugins/element.js'
import './assets/css/global.scss'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/fonts/iconfont.css'

// import { Swiper, SwiperSlide } from 'swiper/vue';
// import 'swiper/swiper-bundle.css';
// Vue.use(Swiper)

import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
// 引入语言资源文件
import en from '@/lang/en.js';
import zh from '@/lang/zh.js';

import VueLazyload from 'vue-lazyload';

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('./assets/img/icon-tupian.png'),
  loading: require('./assets/img/icon-jiazai.gif'),
  attempt: 1
});


Vue.use(ElementUI);
Vue.use(VueI18n);

// 创建 VueI18n 实例
const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    en: en,
    zh: zh
  }
});





// main.js
const resizeObserverErrHandler = (err) => {
  if (err.message.includes('ResizeObserver')) return;
  console.error(err);
};
window.addEventListener('error', resizeObserverErrHandler);


Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
